<template>
  <div class="about">
	  <headerPage></headerPage>
	  <div class="content">
		  <div class="about-content">
			  <div class="about-desc">
				<div>中小学课程管理平台</div>
				<div><i class="el-icon-user info-icon"></i>作者：*********</div>
				<div><i class="el-icon-reading info-icon"></i>年级：*********</div>
				<div><i class="el-icon-collection info-icon"></i>班级：*********</div>
				<div><i class="el-icon-message info-icon"></i>邮箱：example@qq.com</div>
				<div><i class="el-icon-chat-dot-square info-icon"></i>Q Q：3320160706</div>
				<div><i class="el-icon-chat-line-square info-icon"></i>微信：*********</div>
				<div><i class="el-icon-phone-outline info-icon"></i>电话：*********</div>
				<div>没有什么烦恼是敲出一行代码解决不了的，不行，就两行～</div>
			  </div>
			  <img src="../../assets/image/about/about.jpeg">
		  </div>
	  </div>
  </div>
</template>

<script>
  import headerPage from "../../components/header/header"
  export default {
	data() {
	  return{

	  }
	},
	components: {
		headerPage,
	},
	methods: {


	},
	created() {

	},
	mounted() {

	}
 }
</script>

<style scoped>
@import url("../../assets/css/about/about.css");
</style>
